var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoor = function SvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 17.5H18.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 17.5V3.125C4.375 2.95924 4.44085 2.80027 4.55806 2.68306C4.67527 2.56585 4.83424 2.5 5 2.5H15C15.1658 2.5 15.3247 2.56585 15.4419 2.68306C15.5592 2.80027 15.625 2.95924 15.625 3.125V17.5",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 11.25C12.7053 11.25 13.125 10.8303 13.125 10.3125C13.125 9.79473 12.7053 9.375 12.1875 9.375C11.6697 9.375 11.25 9.79473 11.25 10.3125C11.25 10.8303 11.6697 11.25 12.1875 11.25Z",
    fill: "#919191"
  })));
};
export default SvgDoor;